export const emitedEventsTypes: Readonly<any> = {
    selectedPackageEvent: 'selectedPackageEvent',
    receivedPackagesData: 'RECEIVED_PACKAGES_DATA',
    openActivitiesWindow: 'openActivitiesWindow',
    scriptEdit: 'scriptEdit',
    RESET_PACKAGES_SCROLL: 'RESET_PACKAGES_SCROLL'
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/constants/emitedEventsTypes.ts